import type { OrganizationFormValues } from "./OrganizationFormFields";
import type { UpdateOrganizationRequest } from "../../lib/api/users";

export function phoneStorageValue(values: OrganizationFormValues): string {
  return values.phone.trim()
    ? `+${values.phoneCountryCode}${values.phone.trim()}`
    : "";
}

export function patternsEqual(a: string[], b: string[]): boolean {
  if (a.length !== b.length) return false;
  const sortedA = [...a].sort();
  const sortedB = [...b].sort();
  return sortedA.every((value, index) => value === sortedB[index]);
}

export function organizationDetailsPayload(
  values: OrganizationFormValues,
  slug: string,
): UpdateOrganizationRequest {
  const trimmedName = values.name.trim();
  return {
    name: trimmedName,
    slug,
    description: values.description.trim() || undefined,
    logoUrl: values.logoUrl.trim() || undefined,
  };
}

export function organizationContactPayload(
  values: OrganizationFormValues,
): UpdateOrganizationRequest {
  return {
    email: values.email.trim() || undefined,
    phone: phoneStorageValue(values) || undefined,
    address: values.address.trim() || undefined,
    city: values.city.trim() || undefined,
    state: values.state.trim() || undefined,
    zip: values.zip.trim() || undefined,
    country: values.country.trim() || undefined,
  };
}

export function organizationMembershipPayload(
  values: OrganizationFormValues,
): UpdateOrganizationRequest {
  return {
    emailPatterns: values.emailPatterns,
  };
}

export type OrganizationSection = "details" | "contact" | "membership";

export function isDetailsDirty(
  values: OrganizationFormValues,
  saved: OrganizationFormValues,
): boolean {
  return (
    values.name.trim() !== saved.name.trim() ||
    values.description.trim() !== saved.description.trim() ||
    values.logoUrl.trim() !== saved.logoUrl.trim()
  );
}

export function isContactDirty(
  values: OrganizationFormValues,
  saved: OrganizationFormValues,
): boolean {
  return (
    values.email.trim() !== saved.email.trim() ||
    phoneStorageValue(values) !== phoneStorageValue(saved) ||
    values.address.trim() !== saved.address.trim() ||
    values.city.trim() !== saved.city.trim() ||
    values.state.trim() !== saved.state.trim() ||
    values.zip.trim() !== saved.zip.trim() ||
    values.country.trim() !== saved.country.trim()
  );
}

export function isMembershipDirty(
  values: OrganizationFormValues,
  saved: OrganizationFormValues,
): boolean {
  return !patternsEqual(values.emailPatterns, saved.emailPatterns);
}
